import { GenericParty } from "../types/Party";
import getAge from "./getAge";

export default (party: GenericParty, ageLimit: number = 18): boolean =>
  Boolean(party.dateOfBirth && getAge(party.dateOfBirth) < ageLimit);
